import React, { useContext } from "react";

import { EventContext } from "@gp/components";
import { useRootAppStore } from "@hooks";
import { FavoritesStoreContext } from "@state/context/favorites/FavoritesStoreContext";
import { useOfferOptionsContext } from "@state/hooks/offer/useOfferOptionsContext";
import { MobilePlatform } from "@state/stores/types";
import { THEME_SETTINGS } from "@theme-settings";
import classnames from "classnames";
import { observer } from "mobx-react";

export const EventFavoritesIcon = !THEME_SETTINGS.features.isFavoritesEnabled
	? () => null
	: observer(function EventFavoritesIcon() {
			const event = useContext(EventContext);
			const rootStore = useRootAppStore<MobilePlatform>();
			const offerOptions = useOfferOptionsContext();

			const favoriteStore = useContext(FavoritesStoreContext);

			if (offerOptions.isOfferHistory) {
				return null;
			}
			const isFavorite = favoriteStore.isUserFavoriteEvent(event.id);

			function toggleFavorites(e: React.MouseEvent<HTMLButtonElement>) {
				e.preventDefault();
				if (!rootStore.userAuthStore.isLoggedIn) {
					rootStore.favoritePopupStore.activatePopup();
					return;
				}
				if (isFavorite) {
					favoriteStore.removeUserFavoriteEvent(event.id);
				} else {
					favoriteStore.addUserFavoriteEvent(event.id);
				}
			}

			return (
				<>
					<button
						type="button"
						onClick={toggleFavorites}
						className="at-LiveFavs match__favs__btn btn btn--square btn--square--reset btn--ghost"
					>
						<i
							className={classnames(
								"match__favs__icon u-icon u-icon--xsml",
								{
									"u-icon--star--str u-color--sent--warning":
										isFavorite,
									"u-icon--star--alt": !isFavorite,
									"u-color--sent--muted":
										!isFavorite &&
										!rootStore.userAuthStore.isLoggedIn,
								}
							)}
						/>
					</button>
				</>
			);
		});
